import {
  NotificationContentCategory,
  NotificationType,
} from '@/features/notifications/notification-types';

export enum NotificationReadStatus {
  UNSEEN = 'unseen',
  SEEN = 'seen',
}

export const notificationFilterStatusOptions = [
  NotificationReadStatus.UNSEEN,
  NotificationReadStatus.SEEN,
];

export const notificationTypeOptions = Object.values(NotificationType);

export const notificationContentCategoryOptions = Object.values(
  NotificationContentCategory,
);
